// extracted by mini-css-extract-plugin
export default {"container":"Naa-z","oos":"Oaa-z","oosUx":"Paa-z","selected":"Qaa-z","labelOos":"Raa-z"};